
import {tap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { Observable } from 'rxjs';

import { AuthService } from './auth.service';
import { FuseConfigService } from './config.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {LogsService} from './logs.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  constructor(private auth: AuthService, private fuseConfig: FuseConfigService,
              private spinner: NgxSpinnerService, private logsService: LogsService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {}, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err && err.status && err.status === 401) {
          console.log('error!!!!');
          setTimeout(() => {
            // this.logsService.addLogs('logout').subscribe(resultLog => {
            // });
            this.auth.logout();
            this.spinner.hide();
            window.location.reload();
          }, 1000);
        }
      }
    }));
  }
}
